import React, { useContext } from 'react';

import { Select } from '@imgly/imgly-website-components';
import { useLocation } from '@reach/router';
import classNames from 'classnames';
import { navigate } from 'gatsby';

import { PageContext } from '../../context/PageContext';
import { getInternalPath } from '../../utils';

import * as classes from './style.module.scss';

interface Props {
  className?: string;
}

export const PlatformMenu: React.FC<Props> = ({ className }) => {
  const { pathname } = useLocation();
  const { name, platform, platforms } = useContext(PageContext);

  if (!platforms || !platform || !platforms[platform]) return null;

  const handleChange = (id: string) => {
    navigate(getInternalPath(platforms[id].entryPoint || '', pathname, name));
    // remove the value if a platform is changed
    sessionStorage.removeItem('navigation-scroll-pos');
  };

  const options = Object.entries(platforms).map(([id, { title }]) => ({
    value: id,
    label: title,
  }));

  return (
    <Select
      className={classNames(className, classes.root)}
      selectClassName={classes.select}
      aria-label="Switch the displayed platform"
      onChange={handleChange}
      label={platforms[platform].title}
      value={platform}
      options={options}
    />
  );
};
